import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-white shadow-md sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center text-2xl font-bold text-emerald-700">
                            <img src="/logo-hebitren.jpeg" alt="Logo HEBITREN" className="h-10 w-10 mr-3 object-contain" />
                            HEBIPEDIA
                        </Link>
                    </div>
                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-6">
                        <Link to="/" className="text-gray-600 hover:text-emerald-600 font-medium">Beranda</Link>
                        <Link to="/tentang" className="text-gray-600 hover:text-emerald-600 font-medium">Tentang</Link>
                        <Link to="/keanggotaan" className="text-gray-600 hover:text-emerald-600 font-medium">Keanggotaan</Link>
                        <Link to="/direktori" className="text-gray-600 hover:text-emerald-600 font-medium">Direktori</Link>
                        <Link to="/login" className="text-emerald-600 font-medium px-4 py-2 border border-emerald-600 rounded-md hover:bg-emerald-50">
                            Login
                        </Link>
                        <Link to="/daftar" className="bg-emerald-600 text-white font-medium px-4 py-2 rounded-md hover:bg-emerald-700 shadow-sm">
                            Daftar Anggota
                        </Link>
                    </div>
                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center">
                        <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 focus:outline-none">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {isOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-white border-t">
                    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                        <Link to="/" className="block px-3 py-2 text-gray-600 hover:bg-emerald-50 hover:text-emerald-600 rounded-md">Beranda</Link>
                        <Link to="/tentang" className="block px-3 py-2 text-gray-600 hover:bg-emerald-50 hover:text-emerald-600 rounded-md">Tentang</Link>
                        <Link to="/keanggotaan" className="block px-3 py-2 text-gray-600 hover:bg-emerald-50 hover:text-emerald-600 rounded-md">Keanggotaan</Link>
                        <Link to="/direktori" className="block px-3 py-2 text-gray-600 hover:bg-emerald-50 hover:text-emerald-600 rounded-md">Direktori</Link>
                        <Link to="/login" className="block px-3 py-2 text-emerald-600 font-medium">Login</Link>
                        <Link to="/daftar" className="block px-3 py-2 text-emerald-600 font-bold">Daftar Anggota</Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;